<template>
  <v-dialog max-width="500px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="cancel()">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto;">
        <v-flex xs12>
          <v-layout row>
            <label class="text-icon">Icon :</label>
            <img height="60px" width="60px" :src="logoSrc" alt v-if="logoSrc != null" class="ml-3" />
            <v-card
              v-if="logoSrc == null"
              height="60px"
              width="60px"
              color="grey"
              class="ml-3 text-xs-center pt-3"
            >
              <v-icon color="white">photo</v-icon>
            </v-card>
            <v-btn
              class="black--text ml-3 mt-3"
              @click="$refs.LogoInput.click()"
            >{{logoSrc == null ? 'add icon' : 'edit icon'}}</v-btn>
          </v-layout>
        </v-flex>
        <input
          style="display:none;"
          type="file"
          @change="onIconSelected"
          ref="LogoInput"
          accept="image/*"
        />
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="selectedItem.store_type_name_th"
            required
            label="Store Type Name TH"
            :rules="[validation.required]"
          ></v-text-field>
          <v-text-field
            v-model="selectedItem.store_type_name_en"
            required
            label="Store Type Name EN"
            :rules="[validation.required]"
          ></v-text-field>
          <v-text-field
            v-model="selectedItem.store_type_name_cn"
            required
            label="Store Type Name CN"
          ></v-text-field>
          <v-select
            :items="services"
            item-text="store_service_name_th"
            item-value="store_service_id"
            label="Store service"
            v-model="selectedItem.store_type_service_id"
            :rules="[(v) => !!v || 'Item is required']"
          ></v-select>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="cancel()">Cancel</v-btn>
        <v-btn
          color="green"
          flat
          @click="save()"
          :disabled="updating_data || isEditStoreList"
          :loading="updating_data"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "selectedItem"],
  data() {
    return {
      updating_data: false,
      logoSrc: null,
      valid: true,
      change_logo: 0,
      validation: {
        required: value => !!value || "Required."
      }
    };
  },
  computed: {
    ...mapState({
      services: state => state.fetchStoreBack.store_type.store_services
    }),
    ...mapGetters(["isEditStoreList"]),
    formTitle() {
      return this.editedIndex === -1 ? "New store type" : "Edit store type";
    }
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.change_logo = 0;
        this.logoSrc = null;
        if (this.editedIndex != -1) {
          this.logoSrc = this.selectedItem.store_type_image;
        }
      }
    }
  },
  methods: {
    onIconSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.logoSrc = reader.result;
        this.selectedItem.store_type_image = reader.result;
        this.change_logo = 1;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex == -1) {
          if (this.selectedItem.store_type_image && this.change_logo == 0) {
            delete this.selectedItem.store_type_image;
          }
          let obj1 = JSON.parse(JSON.stringify(this.selectedItem));
          delete obj1.store_type_service_name;
          this.$store.dispatch("fetchStoreBack/addStoreType", obj1);
          this.$emit("save", this.$refs);
        } else {
          let checksuccess;
          this.updating_data = true;
          let obj2 = JSON.parse(JSON.stringify(this.selectedItem));
          delete obj2.store_type_service_name;
          if (obj2.store_type_image && this.change_logo == 0) {
            delete obj2.store_type_image;
          }
          checksuccess = await this.$store.dispatch(
            "fetchStoreBack/editStoreType",
            obj2
          );
          this.updating_data = false;
          if (checksuccess == false) {
            this.$emit("cancel", this.$refs);
          } else {
            this.$emit("save", this.$refs);
          }
        }
      }
    },
    cancel() {
      if (this.updating_data == false) {
        this.$emit("cancel", this.$refs);
      }
    }
  }
};
</script>

<style scoped>
.text-icon {
  font-size: 17px;
  margin-top: 20px;
  color: #616a6b;
}
</style>



